import { styled } from 'linaria/react';

export const StretchBannerImgWrapper = styled.div<{modelWidth: number, modelHeight: string}>`
  max-width: ${({ modelWidth }) => modelWidth}px;
  width: 100%;
  max-height: ${({ modelHeight }) => modelHeight}px;;
  box-sizing: border-box;
  overflow: hidden;
`